<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      v-if="ticket && company"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!isClosed || isNew">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'TicketList'}">
            Tickets
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="ticket && ticket.title">
          <span class="has-text-weight-normal has-text-grey-dark is-uppercase">{{ ticket.subject | ticketSubject }}</span>
        </div>
      </template>
      <a
        v-if="!isClosed"
        slot="dropdown-content"
        @click="updateTicketStatus('closed')"
        class="dropdown-item">
        <span
          class="icon is-medium"
          v-helper.left="'3vydvvrwDXf1CVyFX0WKhF'"><i class="fas fa-times"></i></span><span class="is-margin-left-xsmall">Clore le ticket</span>
      </a>
      <a
        v-if="isNew && !isTicketCreator"
        slot="dropdown-content"
        @click="updateTicketStatus('in_progress')"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-check"></i></span><span class="is-margin-left-xsmall">Prendre en charge le ticket</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="ticket && company && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="true"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right">
              <div class="is-border is-border--circle is-clipped">
                <div
                  class="has-text-white is-size-1 is-clipped is-relative has-background-light--darken2"
                  style="width: 126px; height: 126px; line-height: 126px;">
                  <img
                    v-if="isTicketCreator && adminInCharge && adminInCharge.picture"
                    :src="adminInCharge.picture|avatarBig">
                  <img
                    v-else-if="isTicketCreator && company.picture"
                    :src="company.picture|avatarBig">
                  <img
                    v-else-if="!isTicketCreator && ticket.user.picture"
                    :src="ticket.user.picture|avatarBig">
                  <i
                    v-else
                    class="is-absolutecenter fas fa-user-tie fa-6x"></i>
                </div>
              </div>
            </figure>
            <div
              v-if="!isTicketCreator && ticket.user && ticket.user.last_name && ticket.user.first_name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b id="userName">{{ ticket.user.last_name }} {{ ticket.user.first_name }}</b>
            </div>
            <div
              v-else-if="isTicketCreator"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b id="userName">{{ company.name }}</b>
            </div>
            <div
              class="is-size-5 has-text-weight-light"
              v-if="!isTicketCreator && ticket.user.profil">
              {{ ticket.user.profil | profilTypeLabel }}
              <span v-if="ticket.user.account">
                chez <b>
                  <router-link
                    v-if="(isAdmin || isManager)"
                    :to="{name: 'CompanyVue', params: {id: ticket.user.account.pk}}">{{ ticket.user.account.name }}
                  </router-link>
                  <span v-else>{{ ticket.user.account.name }}</span>
                </b>
              </span>
            </div>
          </div>
          <div
            class="is-padding is-border-top"
            v-if="ticket.user.account.pk !== ticket.promoteur.pk">
            <div class="columns is-multiline">
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Mail :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      v-if="!isTicketCreator"
                      :href="`mailto:${ticket.user.email}`"
                      class="is-underline">{{ ticket.user.email }}</a>
                    <a
                      v-else
                      :href="`mailto:${company.email}`"
                      class="is-underline">{{ company.email }}</a>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Téléphone :</b>
                  </div>
                  <div class="column is-size-6">
                    <phone-number
                      v-if="!isTicketCreator"
                      :phone="ticket.user.phone"></phone-number>
                    <phone-number
                      v-else
                      :phone="company.phone"></phone-number>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-padding is-border-top">
            <div class="columns is-multiline">
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-margin-right-xsmall">
                    <b>Information société</b>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Mail :</b>
                  </div>
                  <div class="column is-size-6 is-break-word">
                    <a
                      :href="`mailto:${company.email}`"
                      class="is-underline">{{ company.email }}</a>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Téléphone :</b>
                  </div>
                  <div class="column is-size-6">
                    <phone-number :phone="company.phone"></phone-number>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-paddingless-bottom">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow is-w80p is-margin-right-xsmall">
                    <b>Adresse :</b>
                  </div>
                  <div class="column is-size-6 is-underline">
                    <a
                      @click="openGoogleMap(company.address)"
                      v-if="company.address">
                      <div v-if="company.address.line1">{{ company.address.line1 }}</div>
                      <div v-if="company.address.line2">{{ company.address.line2 }}</div>
                      <div>
                        <span v-if="company.address.zip_code">{{ company.address.zip_code }}</span>
                        <span v-if="company.address.city">{{ company.address.city }}</span>
                        <i v-if="company.address.country && company.address.country.trim().toLowerCase() !== 'france'">{{ company.address.country }}</i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list
          v-if="$route.params.id"
          :field="'ticket'"></event-tracker-list>
      </template>
      <div class="has-background-white is-border">
        <div class="column is-12 columns is-gapless is-multiline is-padding is-marginless-bottom">
          <div class="column is-12">
            <div class="level is-padding-left-xsmall">
              <div class="level-left">
                <div
                  class="is-padding-bottom-xsmall">
                  <p><b>Objet : </b>{{ ticket.title }}</p>
                  <p
                    v-if="ticket.admin_in_charge"
                    class="is-italic is-size-6">
                    <b>Pris en charge par : {{ ticket.admin_in_charge.last_name }} {{ ticket.admin_in_charge.first_name }} le {{ ticket.taken_in_charge_date | prettyDatetime }} </b>
                  </p>
                </div>
              </div>
              <div
                v-if="(!isTicketCreator && ticket.status == 'new')"
                class="level-right">
                <div class="column ">
                  <button
                    @click="updateTicketStatus('in_progress')"
                    class="button is-black is-fullwidth is-radiusless is-padding">
                    <span class="has-text-weight-medium is-uppercase is-size-7">Prévenir le correspondant de la prise en charge de sa demande</span>
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.left="'3vydvvrwDXf1CVyFX0WKhF'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- MESSAGES -->
          <div
            v-if="ticket.messages && ticket.messages.length"
            id="message-container"
            class="has-background-white is-12 column is-overflow-auto"
            style="max-height:60vh;">
            <div
              v-for="(msg, index) in ticket.messages"
              :key="msg.pk"
              :id="index == (ticket.messages.length -1) ? 'lastmessage': '' "
              class="vadDiscussion column is-12 columns is-multiline">
              <div class="column is-1 is-flex-center">
                <div class="message-picture is-flex-center is-centered">
                  <!-- <img
                    v-if="adminInCharge && msg.user.pk === adminInCharge.pk && adminInCharge.picture"
                    style="width: 50px; height: 50px"
                    :src="adminInCharge.picture|avatarBig">
                  <img
                    v-else-if="msg.user.pk === ticket.user.pk && ticket.user.picture"
                    style="width: 50px; height: 50px"
                    :src="ticket.user.picture|avatarBig"> -->
                  <!-- Modification back pour avoir la photo de profil dans msg.user + affichage -->
                  <img
                    v-if="msg.user && msg.user.picture"
                    style="width: 50px; height: 50px"
                    :src="msg.user.picture|avatarBig">
                  <i
                    v-else
                    class="fas fa-user-tie fa-3x"></i>
                </div>
              </div>
              <div
                v-if="editMessagePk !== msg.pk"
                class="column is-11 vadDiscussion--bulle is-size-5 is-margin-top-xsmall"
                :class="{'is-classic': msg.user.pk != currentUser.pk}">
                <div
                  class="content is-break-word"
                  v-html="msg.message" />
              </div>
              <div
                v-else
                class="column is-11">
                <textarea
                  v-model="editMessageValue"
                  rows="2"
                  class="textarea has-fixed-size"
                  name=""
                  placeholder="Votre message ici ..."
                  id=""></textarea>
                <div class="column is-12">
                  <div class="level columns">
                    <div class="level-left" />
                    <div
                      class="level-right columns is-padding-top-small"
                      style="margin-bottom:auto;">
                      <div class="column">
                        <button
                          @click="editMessagePk = null"
                          class="button is-black is-fullwidth is-radiusless is-padding-left-large is-padding-right-xlarge">
                          <span class="is-uppercase as-text-weight-medium is-size-7">annuler</span>
                        </button>
                      </div>
                      <div
                        class="column">
                        <button
                          :disabled="editMessageValue === msg.message || !editMessageValue"
                          @click="editMessage(msg.pk)"
                          class="button is-success is-fullwidth is-radiusless is-padding-left-small is-padding-right-xlarge">
                          <span class="is-uppercase as-text-weight-medium is-size-7">modifier message</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- MESSAGE SENDER INFO -->
              <div class="level column is-12">
                <div class="level-left">
                  <div class="is-size-7">
                    <div>
                      <b>Date : </b>{{ msg.created_on | prettyDatetime }}<span
                        class="is-italic"
                        v-if="msg.is_modified"> (Modifié)</span>
                    </div>
                    <div>
                      <span v-if="msg.user.pk == currentUser.pk"><b>Auteur : </b>Vous</span>
                      <span v-else><b>Auteur : </b>{{ msg.user.last_name }} {{ msg.user.first_name }}</span>
                      <span v-if="currentUser.pk === msg.user.pk && userLastMessagePk === msg.pk && !editMessagePk && !isClosed">
                        <span> - </span>
                        <a
                          @click="openEditMessageToolbox(msg, index)"
                          class="is-linkTextPicto is-size-7">
                          <span>
                            <i>Modifier votre message</i>
                          </span>
                        </a>

                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="msg.documents.length"
                  class="level-right">
                  <span
                    v-for="pj in msg.documents"
                    :key="pj.pk">
                    <a
                      target="_blank"
                      :href="pj.path"
                      :download="pj.filename"
                      class="button is-white is-small">
                      <span class="icon is-large"><i class="fal fa-lg fa-paperclip" /></span>
                      <!-- <span>Consulter pièce jointe</span> -->
                      <span>{{ pj.filename | truncate(30) }}</span>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <span id="lastmessageid"></span>
          </div>
          <!-- TEXT AREA -->
          <div
            v-if="!isClosed"
            class="column is-12">
            <div class="field">
              <div class="control">
                <textarea
                  @input="message.message = $event.target.value"
                  class="textarea has-fixed-size"
                  name=""
                  placeholder="Votre message ici ..."
                  id=""></textarea>
              </div>
            </div>
          </div>
          <div
            v-if="isClosed && ticket.closed_date"
            class="column is-12 is-fullwidth is-minH50p">
            <div
              class="notification is-black has-text-centered is-marginless">
              <p
                class="is-uppercase is-size-7">
                <span class="has-text-weight-medium is-uppercase">ticket de support cloturé le {{ ticket.closed_date | prettyDatetime }}</span>
              </p>
            </div>
          </div>
          <div
            v-if="!isClosed"
            class="column is-12 is-padding-top-small">
            <div class="level">
              <!-- UPLOAD FILE -->
              <div class="level-left">
                <div class="column">
                  <div
                    class="columns"
                    v-for="document in message.documents"
                    :key="document.fus_id">
                    <ticket-upload-file
                      @upload="onUpload($event)"
                      @delete="onDelete($event)"
                      :document="document" />
                  </div>
                  <div
                    v-if="message.documents.length < 4"
                    class="columns">
                    <ticket-upload-file @upload="onUpload($event)" />
                  </div>
                </div>
              </div>
              <!-- BUTTONS -->
              <div
                class="level-right columns"
                style="margin-bottom:auto;">
                <div class="column">
                  <button
                    @click="updateTicketStatus('closed')"
                    class="button is-black is-fullwidth is-radiusless is-padding-left-large is-padding-right-large">
                    <span class="is-uppercase as-text-weight-medium is-size-7">cloturer ticket</span>
                  </button>
                </div>
                <div
                  class="column">
                  <button
                    :disabled="(message.documents.length <= 0 || (message.message == null || message.message == &quot;&quot;)) && (message.message == null || message.message == &quot;&quot;)"
                    @click="sendMessage()"
                    class="button is-success is-fullwidth is-radiusless is-padding-left-large is-padding-right-large">
                    <span class="is-uppercase as-text-weight-medium is-size-7">envoyer message</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { mapGetters } from 'vuex'
import { bus, EVENTS } from '@/bus'
export default {
  name: 'TicketVue',
  components: {
    TicketUploadFile: () => import('./TicketUploadFile')
  },
  mixins: [DefaultValues],
  data () {
    return {
      loading: false,
      ticket: null,
      company: null,
      message: {
        message: null,
        documents: []
      },
      editMessagePk: null,
      editMessageValue: null,
      adminInCharge: null,
      takenInChargeDate: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager']),
    ticketPk () {
      return this.$route.params.id
    },
    status () {
      return this.ticket.status
    },
    isClosed () {
      return this.ticket.status === 'closed'
    },
    isNew () {
      return this.status === 'new'
    },
    isTicketCreator () {
      return this.currentUser.pk === this.ticket.user.pk
    },
    /**
     * Users can only edit their last message
     */
    userLastMessagePk (msgPk, userPk) {
      const userAllMessages = this.ticket.messages.filter(msg => {
        return msg.user.pk === this.currentUser.pk
      })
      return userAllMessages[userAllMessages.length - 1].pk
    }
  },
  watch: {
    ticket: {
      handler: function (val, oldVal) {
        this.setViewToBottom()
      },
      deep: true
    }
  },
  async created () {
    const accountId = await this.getTicketData()
    await this.getAccount(accountId)
    bus.$on(EVENTS.TICKET_MESSAGE, async (data) => {
      await this.getTicketData()
    })
    this.setViewToBottom()
    if (this.ticket.admin_in_charge) {
      this.adminInCharge = await this.getUser(this.ticket.admin_in_charge.pk)
    }
  },
  methods: {
    /**
       * get users
       * @param {string} query
       */
    async getUser (id) {
      try {
        const { data } = await this.$api.getOne(this.$resources.USER, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    openEditMessageToolbox (msg, index) {
      this.editMessagePk = msg.pk
      this.editMessageValue = msg.message
      if (index === this.ticket.messages.length - 1) {
        this.setViewToBottom()
      }
    },
    scrollToLastMessage () {
      this.$scrollTo('#lastmessage', 10, { container: '#message-container' })
    },
    /** set scroll view to bottom of message list */
    setViewToBottom () {
      this.$nextTick(function () {
        var container = this.$el.querySelector('#message-container')
        if (container) container.scrollTop = container.scrollHeight
      })
    },
    onUpload (document) {
      this.message.documents.push(document)
    },
    onDelete (document) {
      this.message.documents = this.message.documents.filter(doc => document.id !== doc.id)
    },
    async sendMessage () {
      this.loading = true
      const message = this.message.message.replace(/(?:\r|\n|\r\n)/g, '<br>')
      const payload = { message, documents: this.message.documents }
      try {
        await this.$api.post(`/tickets/${this.ticketPk}/message`, payload)
        const { data } = await this.$api.getOne(this.$resources.TICKET, this.ticketPk)
        this.ticket = data
        // reset message
        this.message = {
          message: null,
          documents: []
        }
        this.$toasted.global.success('Message envoyé.')
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de l\'envoi du message')
      } finally { this.loading = false }
    },
    /** Get ticket data and return account id to fetch left column info */
    async getTicketData () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.TICKET, this.ticketPk)
        this.ticket = data
        let accountId = data.user.account.pk
        if (this.currentUser.pk === this.ticket.user.pk) accountId = data.promoteur.pk
        return accountId
      } catch (err) {
        this.$router.replace({ name: 'NotFound' })
      } finally { this.loading = false }
    },
    /** Get either the user account data or the company's */
    async getAccount (accountId) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT, accountId)
        this.company = data
      } catch (err) {
        this.$toasted.global.danger('Erreur')
      } finally { this.loading = false }
    },
    async updateTicketStatus (status) {
      if (status === 'closed') {
        let value = await this.$swal({
          title: 'Cloturer un ticket',
          text: 'Cette action entrainera la cloture du ticket. Vous pourrez le consulter et télécharger les pièces jointes mais il ne sera plus possible d\'envoyer ni de recevoir de messages.',
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Valider'
        })
        if (value.dismiss) return null
      }
      const payload = {
        status
      }
      this.loading = true
      try {
        await this.$api.patch(this.$resources.TICKET, this.ticketPk, payload)
        let { data } = await this.$api.getOne(this.$resources.TICKET, this.ticketPk)
        this.ticket = data
        this.$toasted.global.success('Ticket modifié.')
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de la modification du statut du ticket.')
      } finally { this.loading = false }
    },
    async editMessage () {
      try {
        await this.$api.patch(`/tickets/message`, this.editMessagePk, { new_message: this.editMessageValue })
        await this.getTicketData()
        this.editMessageValue = null
        this.editMessagePk = null
        this.$toasted.global.success('Message modifié.')
      } catch (error) {
        this.$toasted.global.danger('Erreur lors de la modification du message.')
      }
    }

  }
}
</script>

<style lang="sass">
.message-picture
  border-radius: 50%
  width: 50px
  height: 50px
  overflow: hidden
</style>
